<template>
  <div>
    <div class="row">
      <div class="col-sm-10"></div>
      <div class="col-sm-2">
        <CustomSelect
          name="filterBy"
          placeholder="Filter By"
          :optionLabel="'name'"
          :options="fsStatFilter"
          v-model="filterBy"
        />
      </div>
    </div>
    <div>
      <apexchart
        height="400"
        width="100%"
        type="bar"
        :options="{
          plotOptions: {
            bar: {
              borderRadius: 0,
            },
          },
        }"
        :series="[
            {
              data: chartData.map((dt) => ({
                x: dt.date,
                y: dt.credit,
              })),
            },
        ]"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import {
  toCurrency,
  formatNumber,
  graphDateFormatter,
  fsStatFilter,
} from "../utils/helpers";
import CustomSelect from "../utils/CustomSelect/CustomSelect";
import logs from "../../services/logs";

export default {
  name: "CreditLogStat",
  data() {
    return {
      chartData: [],
      filterBy: "thisMonth",
      fsStatFilter,
      
    };
  },
  components: { CustomSelect },
  methods: {
    toCurrency,
    formatNumber,
    graphDateFormatter,
    async fetchCreditLogStat(filterBy) {
      const { data } = await logs.GetCreditLogStats(filterBy);
      this.chartData = data.data;
      this.loading = false;
    },
  },
  watch: {
    filterBy(newVal, oldVal) {
      this.fetchCreditLogStat({
        filterBy: newVal.value,
      });
    },
  },
  created() {
    this.fetchCreditLogStat({
      filterBy: this.filterBy,
    });
  },
};
</script>

<style scoped></style>